// eventRenderers.ts

import { GameLog } from '../../../../Logs/LogsDisplay';
import RenderAggregatedDamageEvent from './renderAggregatedDamageEvent';
import RenderAggregatedResourceEvent from './RenderAggregatedResourceEvent';
import RenderAggregatedCrowdControlEvent from './RenderAggregatedCrowdControlEvent';
import DamageEvent from './DamageEvent';
import RenderDefaultLog from './renderDefaultLog';
import RenderPressTheAttackEvent from './renderPressTheAttackEvent';
import StackEvent from './TimeOutEvents/StackEvent';
import DebuffAppliedEvent from './DebuffAppliedEvent';
import HealEvent from './HealEvent';
import StatChangeEvent from './StatChangeEvent';
import PhantomHitEvent from './PhantomHitEvent';
import CrowdControlEvent from './CrowdControlEvent';
import ShieldMitigationEvent from './ShieldMitigationEvent';
import CooldownReductionEvent from './CooldownReductionEvent';
import DamageMultiplierEvent from './DamageMultiplierEvent';
import TimeExtensionEvent from './TimeExtension';
import DamageMitigationEvent from './DamageMitigationEvent';


export interface BaseRendererProps {
  log: GameLog;
}

export type EventRenderer = React.FC<BaseRendererProps>;

const eventRenderers: { [key: string]: EventRenderer } = {
  DamageTaken: DamageEvent,
  RenderAggregatedDamageEvent: RenderAggregatedDamageEvent,
  AggregatedResourceUsage: RenderAggregatedResourceEvent,
  AggregatedCrowdControl: RenderAggregatedCrowdControlEvent,
  DebuffApplied: DebuffAppliedEvent,
  Healing: HealEvent,
  StatChange: StatChangeEvent,
  PhantomHit: PhantomHitEvent, // Register the new event type
  CrowdControl: CrowdControlEvent, // Register the new event type
  ShieldMitigation: ShieldMitigationEvent,
  CooldownReduction: CooldownReductionEvent,
  DamageMultiplier: DamageMultiplierEvent,
  TimeExtension: TimeExtensionEvent,
  StackUpdate: StackEvent,
  DamageMitigation: DamageMitigationEvent,
  // ... other mappings
  Default: RenderDefaultLog,

};

export default eventRenderers;
